import React, { createContext, useState, useEffect } from 'react';

export const TaskContext = createContext();

export const TaskProvider = ({ children }) => {
  const [tasks, setTasks] = useState(() => {
    const storedTasks = localStorage.getItem('tasks');
    return storedTasks ? JSON.parse(storedTasks) : [];
  });
  const [completedTasks, setCompletedTasks] = useState(() => {
    const storedCompleted = localStorage.getItem('completedTasks');
    return storedCompleted ? JSON.parse(storedCompleted) : [];
  });

  useEffect(() => {
    localStorage.setItem('tasks', JSON.stringify(tasks));
  }, [tasks]);

  useEffect(() => {
    localStorage.setItem('completedTasks', JSON.stringify(completedTasks));
  }, [completedTasks]);

  const addTask = (task) => {
    setTasks([...tasks, task]);
  };

  const removeTask = (taskId) => {
    setTasks(tasks.filter(task => task.id !== taskId));
  };

  const completedTask = (taskCompleted) => {
    setTasks(tasks.filter(task => task.id !== taskCompleted.id));
    setCompletedTasks([...completedTasks, taskCompleted]);
  };

  const editTask = (updatedTask) => {
    setTasks(tasks.map(task => (task.id === updatedTask.id ? updatedTask : task)));
  };

  const values = {
    tasks,
    addTask,
    removeTask,
    completedTask,
    completedTasks,
    editTask,
  };


  return (
    <TaskContext.Provider value={values}>
      {children}
    </TaskContext.Provider>
  );
};